// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobileCurrentFilters-root-GIJ {\n  z-index: 11;\n}\n\n.mobileCurrentFilters-triggerRoot-QSr {\n}\n\n.mobileCurrentFilters-itemsWrapper-VdV {\n}\n\n.mobileCurrentFilters-item-CU9 {\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "mobileCurrentFilters-root-GIJ fixed bottom-0 left-0 w-full bg-bronze p-4",
	"triggerRoot": "mobileCurrentFilters-triggerRoot-QSr underline",
	"itemsWrapper": "mobileCurrentFilters-itemsWrapper-VdV flex flex-wrap pb-4",
	"item": "mobileCurrentFilters-item-CU9 list-none"
};
export default ___CSS_LOADER_EXPORT___;
